import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import aiEyeImage from '../assets/Homepage-image.png';
import './HomePage.css';
import fileIcon from '../assets/file.png';
import Navigation from './Navigation';
import xLogo from '../assets/X_logo_2023_(white).png';
import { CSSTransition } from 'react-transition-group';
import '../styles/Transitions.css';

const HomePage = () => {
  const [showFooter, setShowFooter] = useState(false);

  const handleScroll = useCallback(() => {
    // Get scroll position from multiple possible sources
    const scrollPosition = window.pageYOffset || 
                         document.documentElement.scrollTop || 
                         document.body.scrollTop;

    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
      document.documentElement.clientHeight,
      document.body.scrollHeight,
      document.body.offsetHeight
    );
    
    // Calculate threshold (20% of viewport height)
    const scrollThreshold = windowHeight * 0.2;
    
    // Show footer if scrolled past threshold or near bottom of page
    setShowFooter(
      scrollPosition > scrollThreshold || 
      (documentHeight - (scrollPosition + windowHeight)) < 100
    );
  }, []);

  useEffect(() => {
    // Initial check
    handleScroll();
    
    // Add passive event listeners for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div className="home-container">
      <Navigation />
      {/* Hero Section */}
      <main className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Welcome to

            <div className="aisee-line">
              $AISEE <span role="img" aria-label="wave">👋</span>
            </div>
          </h1>
          <p className="hero-slogan">Empowering sight, revealing the unseen.</p>
        </div>
        <div className="hero-image">
          <img src={aiEyeImage} alt="AI Eye Visualization" />
        </div>
      </main>
      
      <footer className={`footer ${showFooter ? 'visible' : ''}`}>
        <div className="footer-copyright">
          © 2025 What-can-AI-see?
        </div>
        <div className="footer-social">
          <a href="https://x.com/whatcanaisee?s=21" target="_blank" rel="noopener noreferrer">
            <img src={xLogo} alt="X (Twitter) Profile" className="x-logo" />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default HomePage; 